import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Input, InfiniteScroll, Fab, Breadcrumbs } from '../../../components/UI/ComponentsUI';
import { translate, closeCollapsible, showMessageToastCustom, downloadFile } from '../../../utils/util';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import { onValueChange } from '../../../utils/handleChangeHooks';
import * as actionsStock from '../../../actions/stockAction';
import M from 'materialize-css/dist/js/materialize';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import StockService from '../../../services/StockService';
import { ENUMS } from '../../../utils/constants';
import Select from '../../../components/UI/Select';

const PalletLabelList = (props) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemDelete, setItemDelete] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [filter, setFilter] = useState({
        area: '',
        street: '',
        positionIni: '',
        positionFinal: '',
        level: '',
        positionOrientarion: 0
    });

    useEffect(() => {
        if (props.palletLabelsPaged?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData([...props.palletLabelsPaged.items]);
            } else {
                setData((prevState) => ([...prevState, ...props.palletLabelsPaged.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props?.palletLabelsPaged?.items]);

    useEffect(() => {
        getFilter();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getFilter(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const getFilter = (click) => {
        var currentPageList = click ? 0 : currentPage;
        if (click) {
            setSelectedItems([])
            setCurrentPage(0);
        }

        props.getPallets(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPageList
        }), () => {
            closeCollapsible("filterqmePartNumber")
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onDelete = () => {
        props.deletePallet(itemDelete.id, (response) => {
            if (response) {
                showMessageToastCustom(translate('general.info'), translate('sucess-to-delete', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                getFilter(true)
            }

            setItemDelete(null)
        });
    }

    const onClickDelete = (item) => {
        setItemDelete(item)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    }

    const onSelectItem = (item) => {
        props.setPallet(item)
        props.history.push({
            pathname: './registration',
            state: { update: true }
        })
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedItems);
        let index = selectedItems.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedItems(arr)
    }

    const deleteSelectedItems = () => {
        props.deleteSelected(selectedItems, () => {
            setCurrentPage(0);
            getFilter();
        })
    }

    const reportLabels = (items) => {
        props.getReportLabels(items, (response) => {
            downloadFile(response, `pallets.pdf`, "data:application/pdf", true)
        })
    }


    return (
        <div>
            <Breadcrumbs title={{ icon: "mdi mdi-clipboard-list-outline", label: translate('stock:pallet-list') }} />
            <i className={`mdi mdi-36px mdi-sticker-plus above-btn`} style={{ cursor: 'pointer' }} onClick={() =>
                props.history.push('./registration')} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterqmePartNumber"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        onChange={onChange}
                                        label="Área"
                                        id="area"
                                        name="area"
                                        type="text"
                                        value={filter.area || ''}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        onChange={onChange}
                                        label="Rua"
                                        id="street"
                                        name="street"
                                        type="text"
                                        value={filter.street || ''}
                                        numericonly="true"
                                        leadingzeros={2}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        onChange={onChange}
                                        label="Posição Inicial"
                                        id="positionInit"
                                        name="positionInit"
                                        type="text"
                                        value={filter.positionInit || ''}
                                        numericonly="true"
                                        leadingzeros={3}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        onChange={onChange}
                                        label="Posição Final"
                                        id="positionFinal"
                                        name="positionFinal"
                                        type="text"
                                        value={filter.positionFinal || ''}
                                        numericonly="true"
                                        leadingzeros={3}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        onChange={onChange}
                                        label="Nível"
                                        id="level"
                                        name="level"
                                        type="text"
                                        value={filter.level || ''}
                                        numericonly="true"
                                        leadingzeros={2}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        onChange={onChange}
                                        label="Endereço"
                                        id="adress"
                                        name="adress"
                                        type="text"
                                        value={filter.adress || ''}
                                    />
                                </div>
                                <div className="input-field  no-padding col s11">
                                    <Select
                                        required
                                        id="positionOrientarion"
                                        name="positionOrientarion"
                                        display="name"
                                        label={translate('side', 'stock')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: ENUMS.eTypeOrdenation.All.value, text: translate(ENUMS.eTypeOrdenation.All.text, 'stock') },
                                            { id: ENUMS.eTypeOrdenation.Pair.value, text: translate(ENUMS.eTypeOrdenation.Pair.text, 'stock') },
                                            { id: ENUMS.eTypeOrdenation.Odd.value, text: translate(ENUMS.eTypeOrdenation.Odd.text, 'stock') },
                                        ]}
                                        change={(e) => {
                                            onChange(e);
                                        }}
                                        defaultValue={filter.positionOrientarion}
                                    />
                                </div>
                            </div>
                        }
                    />
                    <div className="row" style={{ paddingTop: '3px' }}>
                        <Button
                            full="true"
                            text={translate('search', 'general')}
                            onClick={() => getFilter(true)} />
                    </div>
                </div>
                {selectedItems.length > 0 &&
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('change-location:delete-selected')} onClick={() => deleteSelectedItems()} />
                    </div>
                }
                <InfiniteScroll
                    page={props.palletLabelsPaged.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.palletLabelsPaged.totalPages}
                    data={data?.map((item) => (
                        <div key={item?.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px' }} >
                            <div onClick={() => onSelectItem(item)}>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>{item.adress}</span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>Area: {item.area}</span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>Rua: {item.street}</span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>Posição: {item.position}</span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>Altura: {item.level}</span>
                            </div>
                            <div>
                                <span className="title sixth-text-color" style={{ display: 'block' }}>
                                    <i style={{ cursor: 'pointer' }} onClick={() => onClickDelete(item)} className="mdi mdi-delete"></i>
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }}>
                                    <i style={{ cursor: 'pointer' }} onClick={() => reportLabels([item.id])} className="mdi mdi-printer"></i>
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }}>
                                    <Input
                                        type="checkbox"
                                        onChange={() => onCheckItem(item)}
                                        id="select"
                                        name="select"
                                        checked={selectedItems.find(f => f === item.id) || false}
                                    />
                                </span>
                            </div>
                        </div>
                    ))}
                />
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
            {
                data && data.length > 0 &&
                <Fab
                    buttons={[
                        { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                        {
                            label: "Selecionar Todos", icon: <i className="mdi mdi-publish" />, onClick: () => {
                                data.forEach((item) => {
                                    if (!selectedItems.includes(item.id)) {
                                        selectedItems.push(item.id);
                                    }
                                });
                                setSelectedItems([...selectedItems]);
                            }
                        },
                        {
                            label: "Gerar etiqueta(s)", icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => {
                                if (selectedItems.length > 0) {
                                    reportLabels(selectedItems)
                                }
                            }
                        },
                        { label: "Limpar Selecionados", icon: <i className="mdi mdi-publish" />, onClick: () => setSelectedItems([]) },
                        {
                            label: translate('change-location:delete-selected'), color: 'darkred', icon: <i className="mdi mdi-delete" />, onClick: () => {
                                if (selectedItems.length > 0) {
                                    deleteSelectedItems()
                                }
                            }
                        }
                    ]}
                />
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        palletLabelsPaged: state.stockReducer.palletLabelsPaged,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPallets: (filter, callback) => {
            dispatch(StockService.getPalletLabelsPaged(filter, callback));
        },
        setPallet: (mailer) => {
            dispatch(actionsStock.setPalletLabel(mailer))
        },
        deletePallet: (id, callback) => {
            dispatch(StockService.deletePallet(id, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(StockService.deleteSelectedPallets(selectedIds, callback));
        },
        getReportLabels: (selectedIds, callback) => {
            dispatch(StockService.getReportLabels(selectedIds, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PalletLabelList));